module.exports = __webpack_public_path__ + "static/edit_content-f51effcf800d9fc4109cc01312e7ae65.png";